import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/Auth.context';
import NavButton from '../NavButton';
import { routes, dashboardPaths } from '../../constants';
import styles from './DashboardNav.module.scss';

const DashboardNav = ({ section }) => {
  const [authState] = useContext(AuthContext);
  const isIQUser = authState.iq;

  const isStartNewApp = section === dashboardPaths.START_APPLICATION;
  const isMyApps = section === dashboardPaths.MY_APPLICATIONS;
  const isMyDocs = section === dashboardPaths.MY_DOCUMENTS;
  const isManageProfile = section === dashboardPaths.APP;

  return (
    <div className={styles.container} data-testid="dashboard-nav">
      <Link to={routes.START_APPLICATION} data-testid="dashboard-nav-start-application">
        <NavButton text='Start New Application' type='secondary' icon='plus' active={isStartNewApp} />
      </Link>
      <hr />
      <div className={styles.options}>
        <Link to={routes.MY_APPLICATIONS} data-testid="dashboard-nav-my-applications">
          <NavButton text='My Applications' active={isMyApps} />
        </Link>
        <Link to={routes.MY_DOCUMENTS} data-testid="dashboard-nav-my-documents">
          <NavButton text='My Documents' active={isMyDocs} />
        </Link>
      </div>
    </div>
  );
};

DashboardNav.propTypes = {
  section: PropTypes.string
};

export default DashboardNav;
